import useUserStore from './modules/user';

const useStore = () => ({
  useUserStore: useUserStore()
})
export default useStore
